import { Outlet } from 'react-router-dom';
import { Layout, Flex } from 'antd';
import TopTabs from './TopTabs';
import { ProjectVersionPicker } from './_shared/ProjectPicker';

const { Content } = Layout;

export default function WithTabsLayout() {
  return (
    <>
      <Flex orientation="horizontal" gap="large" justify="space-between" className="px-4 md:px-6 pt-4">
        <div>
          <h1 className="text-2xl font-bold text-text-primary"> Game Content </h1>
          <p className="text-sm text-text-secondary"> Управление сущностями и параметрами </p>
        </div>
        <ProjectVersionPicker />
      </Flex>
      
      <Content className="px-0 md:px-2 mt-4">
        <TopTabs base="/content" />
        <div className="mt-4">
          <Outlet />
        </div>
      </Content>
    </>
  );
}
